module.exports = __webpack_public_path__ + "static/img/alpaga-01.ec3c869.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alpaga-01.png
// module id = 60
// module chunks = 0